import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorksSection() {
  const steps = [{
    num: '01',
    title: 'Retiro de Energía',
    desc: 'Aplicas el desvanecimiento digital según el Capítulo 3.'
  }, {
    num: '02',
    title: 'Creación del Vacío',
    desc: 'Dejas que el Efecto Zeigarnik trabaje en su mente.'
  }, {
    num: '03',
    title: 'Re-conexión de Alto Valor',
    desc: 'Respondes desde tu nuevo centro de gravedad usando los guiones incluidos.'
  }];
  return <section className="py-20 bg-dark-100 relative overflow-hidden" data-id="element-142">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-143">
        <FadeIn data-id="element-144">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-white mb-16" data-id="element-145">
            Cómo funciona el{' '}
            <span className="text-gold-400 italic" data-id="element-146">Protocolo</span>
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-147">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-gradient-to-r from-transparent via-gold-500/30 to-transparent z-0" data-id="element-148"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-149">
              <div className="flex flex-col items-center text-center group" data-id="element-150">
                <div className="w-24 h-24 rounded-full bg-dark border border-gold-500/30 flex items-center justify-center mb-6 group-hover:border-gold-400 group-hover:shadow-[0_0_20px_rgba(201,168,76,0.2)] transition-all duration-500" data-id="element-151">
                  <span className="text-3xl font-serif text-gold-400 italic" data-id="element-152">
                    {step.num}
                  </span>
                </div>
                <h3 className="text-xl font-serif text-white mb-3" data-id="element-153">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-154">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}